import React from 'react';
import PropTypes from 'prop-types';
import { PARTICIPATION_STATUS } from '../../propTypes/sessionProp';
import translate from '../../../../commonComponents/translate';

const ParticipationStatus = props => {
  const { t, participationStatus } = props;
  return (
    <div className={`session-user-status session-user-status-${participationStatus}`}>
      {t(`session.table.participation.${participationStatus}`)}
    </div>
  );
};

ParticipationStatus.propTypes = {
  t: PropTypes.func.isRequired,
  participationStatus: PropTypes.oneOf(PARTICIPATION_STATUS).isRequired,
};

export default translate(ParticipationStatus);
